import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const FALLBACK_EXT = ["stl", "step", "stp", "3mf"];
export const RUNNING = ["wartet", "laeuft"];
export const familyOf = (a) => a.parent_id || a.id;

export const fmtMinutes = (m) => (m === null || m === undefined ? "–" : `${Math.floor(m / 60)}:${String(m % 60).padStart(2, "0")} h`);
export const fmtGrams = (g) => (g === null || g === undefined ? "–" : `${Number(g).toLocaleString("de-DE", { maximumFractionDigits: 2 })} g`);
// Tatsächlich berechneter Positionsbetrag (wie _compute_totals im Backend) – stimmt immer mit der Positionstabelle überein.
export const positionTotals = (p) => {
  const factor = 1 + Number(p.mwst_satz ?? 19) / 100;
  const menge = Number(p.menge || 0);
  if (p.einzelpreis_brutto !== null && p.einzelpreis_brutto !== undefined) {
    const gross = Number(p.einzelpreis_brutto) * menge;
    return { brutto: Math.round(gross * 100) / 100, netto: Math.round((gross / factor) * 100) / 100 };
  }
  const net = Number(p.einzelpreis_netto || 0) * menge;
  return { brutto: Math.round(net * factor * 100) / 100, netto: Math.round(net * 100) / 100 };
};
export const fmtEur = (v) => (v === null || v === undefined ? "–" : Number(v).toLocaleString("de-DE", { style: "currency", currency: "EUR" }));

// Lädt die letzten Kalkulations-Jobs je Datei und pollt, solange eine Kalkulation läuft.
export function useKalkulation(orderId, onFinished) {
  const [jobs, setJobs] = useState({});
  const [allowedExt, setAllowedExt] = useState(FALLBACK_EXT);
  const prev = useRef({});
  const timer = useRef(null);
  const finishedRef = useRef(onFinished);
  finishedRef.current = onFinished;

  const load = useCallback(async () => {
    clearTimeout(timer.current);
    try {
      const r = await api.get(`/auftraege/${orderId}/kalkulationen`);
      const map = {};
      r.data.jobs.forEach((j) => { map[j.file_family] = j; });
      let finished = false;
      Object.values(map).forEach((j) => {
        const before = prev.current[j.file_family];
        if (before && RUNNING.includes(before.status) && before.id === j.id && !RUNNING.includes(j.status)) {
          finished = true;
          if (j.status === "fertig") toast.success(`${j.file_name}: Kalkulation abgeschlossen.`);
          else toast.error(`${j.file_name}: ${j.message || "Kalkulation fehlgeschlagen."}`);
        }
      });
      prev.current = map;
      setJobs(map);
      setAllowedExt(r.data.allowed_extensions?.length ? r.data.allowed_extensions : FALLBACK_EXT);
      if (finished && finishedRef.current) finishedRef.current();
      if (Object.values(map).some((j) => RUNNING.includes(j.status))) timer.current = setTimeout(load, 2000);
    } catch { /* Anzeige bleibt beim letzten Stand */ }
  }, [orderId]);

  useEffect(() => { load(); return () => clearTimeout(timer.current); }, [load]);
  return { jobs, allowedExt, reload: load };
}
